import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './Badge.scss'

export const BADGE_KIND_PRIMARY = 'primary'
export const BADGE_KIND_SECONDARY = 'secondary'
export const BADGE_KIND_OUTLINE = 'outline'

export const BADGE_TYPE_DEFAULT = 'default'
export const BADGE_TYPE_SUCCESS = 'success'
export const BADGE_TYPE_INFO = 'info'
export const BADGE_TYPE_ERROR = 'error'
export const BADGE_TYPE_WARNING = 'warning'
export const BADGE_TYPE_GREEN = 'green'
export const BADGE_TYPE_ORANGE = 'orange'

export const Badge = ({
  text,
  type,
  kind,
  className,
  classIcon,
  lowercase,
  onClick,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <span
      className={classnames(className, 'e-badge', `e-badge--${type}`, {
        'e-badge--lowercase': lowercase,
        'e-badge--primary': kind === BADGE_KIND_PRIMARY,
        'e-badge--secondary': kind === BADGE_KIND_SECONDARY,
        'e-badge--outline': kind === BADGE_KIND_OUTLINE,
        'e-badge--clickable': !!onClick
      })}
      onClick={onClick}
      data-mu-test={classnames('badge', dataAttributeTest)}
    >
      {classIcon && <span className={classnames('e-badge__icon', classIcon)} />}
      <span className='e-badge__label'>{text}</span>
    </span>
  )
}

Badge.defaultProps = {
  lowercase: false,
  type: BADGE_TYPE_DEFAULT,
  onClick: undefined,
  kind: BADGE_KIND_SECONDARY
}

Badge.propTypes = {
  /**
   * Text of the badge
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Color variant
   */
  type: PropTypes.oneOf([
    BADGE_TYPE_DEFAULT,
    BADGE_TYPE_SUCCESS,
    BADGE_TYPE_INFO,
    BADGE_TYPE_ERROR,
    BADGE_TYPE_WARNING,
    BADGE_TYPE_ORANGE,
    BADGE_TYPE_GREEN
  ]),
  kind: PropTypes.oneOf([
    BADGE_KIND_PRIMARY,
    BADGE_KIND_SECONDARY,
    BADGE_KIND_OUTLINE
  ]),
  /**
   * Additional classes
   */
  className: PropTypes.string,
  /**
   * Classnames that define an icon to show (eg. `fa fa-times`)
   */
  classIcon: PropTypes.string,
  /**
   * Click callback
   */
  onClick: PropTypes.func,
  /**
   * Forces lowercase
   */
  lowercase: PropTypes.bool,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
